<div class="coordenates__trigger" (click)="coordenatesTrigger()" [ngClass]="active ? 'active' : ''">
  RCS: <p>{{ coordenatesController.activeRCS.epsg }} - {{ coordenatesController.activeRCS.name}}</p>
</div>
<div class="coordenates">
    <div class="coordenates__container" [ngClass]="active ? 'active' : ''">
        <div class="row">
            <div class="row__item">
                <div>
                    <label>Coordenates Explorer</label>
                    <div *ngFor="let el of coordenatesController.rcsList">
                      <p>
                        {{ el.epsg }}-{{ el.name }}
                        <span [ngClass]="el.isactive? 'active' : ''" (click)="activateRCS(el)">ACTIVE</span>
                      </p>
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>
